module.exports = __webpack_public_path__ + "r-v3/img/ml_30_00.58456d01.jpg";